import { render, staticRenderFns } from "./StockDiference.vue?vue&type=template&id=1636fe98&"
import script from "./StockDiference.vue?vue&type=script&lang=js&"
export * from "./StockDiference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports